module.exports = __webpack_public_path__ + "img/finance-icon-2.de0606b6.svg";